import { Component } from '@theme/component';

/** Add weekdays to a calendar date represented in UTC to avoid DST arithmetic. */
export function addBusinessDays(date, count) {
  const result = new Date(date);
  for (let added = 0; added < count;) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) added++;
  }
  return result;
}

/** Processing (1-2 weekdays) plus transit (7-12 weekdays), from today's US Eastern date. */
export function deliveryRange(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
  }).formatToParts(now);
  const value = (type) => Number(parts.find((part) => part.type === type)?.value);
  const today = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
  return [addBusinessDays(today, 8), addBusinessDays(today, 14)];
}

/** Live estimate refreshes after Eastern midnight and when a sleeping tab returns. */
class EvenmornDelivery extends Component {
  #timer;
  #events;

  connectedCallback() { super.connectedCallback(); this.#initialize(); }
  updatedCallback() { super.updatedCallback(); this.#initialize(); }
  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#events?.abort();
    super.disconnectedCallback();
  }

  #initialize() {
    clearTimeout(this.#timer);
    this.#events?.abort();
    this.#events = new AbortController();
    document.addEventListener('visibilitychange', this.#refresh, { signal: this.#events.signal });
    this.#refresh();
  }

  #refresh = () => {
    clearTimeout(this.#timer);
    const node = this.querySelector('[data-delivery-estimate]');
    if (!(node instanceof HTMLElement)) return;
    const [start, end] = deliveryRange();
    const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
      timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric',
    });
    const range = (this.dataset.rangeLabel || '').replace('{start}', formatter.format(start)).replace('{end}', formatter.format(end));
    node.textContent = (this.dataset.dateLabel || '').replace('{range}', range);
    node.hidden = false;
    this.#timer = setTimeout(this.#refresh, 60000);
  };
}

if (!customElements.get('evenmorn-delivery')) customElements.define('evenmorn-delivery', EvenmornDelivery);
